import React from 'react';
import { validationClasses } from '@/utils/errors';
import UuidEditor from '@/components/text-editors/UuidEditor';
import { camelConverter } from '../helper';

const FormUuid = ({
  autoFocus,
  disabled,
  error,
  field,
  onChange,
  text,
}) => (
  <UuidEditor
    autoFocus={autoFocus}
    className={validationClasses(error, 'aridhia-form-uuid-input aridhia-is-edit-mode')}
    disabled={disabled}
    fluid
    id={camelConverter(field.name, '_')}
    maxLength={field.validation?.maximum}
    onChange={onChange}
    placeholder={field.placeholder}
    uuid={text || ''}
  />
);

export default FormUuid;
